/**
 * Discount configuration mode.
 */
export enum DiscountConfigurationMode {
  /**
   * Each standard pricing item has its own discount toggle.
   */
  PER_PRICING_ITEM = 'per_pricing_item',

  /**
   * All standard pricing items receive the discount.
   */
  ALL_PRICING_ITEMS = 'all_pricing_items',
}
